interface Props {
  variantCount: number;
  variants: any[];
  selectedVariant: any;
}

export const useAvailableVariantsWithCount = ({
  variantCount,
  variants,
  selectedVariant,
}: Props) => {
  if (!variantCount) {
    return [selectedVariant];
  }

  if (variantCount === 1 || variants.length > 1) {
    return variants;
  }

  return [selectedVariant, selectedVariant];
};
